<template>    
    <div class="modal-mask" v-on:scroll="scrollMove($el)">
        <div class="modal-wrapper">            
            <div class="modal-container d-flex flex-column">
                <div ref="examHeader">
                    <view-header :paperData="paperData"></view-header>
                </div>

                <div class="flex-grow-1">
                    <view-tab @setViewTab="setViewTab" :setTabFixed="setTabFixed"></view-tab>
                    <div class="banner" v-if="campaignData">
                        <a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" target="_blank">
                            <img :src="campaignData.image" alt="" v-if="campaignData.image">
                        </a>
                        <a v-else href="javascript:void(0)" style="cursor:none">
                            <img :src="campaignData.image" alt="">
                        </a>
                    </div>

                    <div :class="setTabFixed && isAction ? 'mgt-50 mgb-60' : ''">
                        <component 
                            :is="tabType"
                            :periodPolicy="periodPolicy"
                            :summary="summary"
                            :pointPolicy="pointPolicy"
                            :badges="badges"
                        ></component>
                    </div>

                    
                </div>

                <view-footer
                    :paperData="paperData"
                    :setTabFixed="setTabFixed"
                ></view-footer>
                
                
            </div>
        </div>
        
    </div>

</template>

<script>
/**
 * 단독 전체 시험 결과 상세 메인 컴포넌트(independent total exam view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import campaignApi from '@/api/campaignApi.js'
import ViewHeader from './view/Header'
import ViewFooter from './view/Footer'
import ViewTab from './view/ViewTab'
import ViewInformation from './view/Information'
import ViewReward from './view/Reward'

export default {
    data() {
        return {
            paperData: null,
            tabType: 'Information',
            setTabFixed: false,

            periodPolicy: null,
            summary: '',
            pointPolicy: null,
            badges: null,
            campaignData: null
        }
    },
    components: {
        'view-header': ViewHeader,
        'view-footer': ViewFooter,
        'view-tab': ViewTab,
        'Information': ViewInformation,
        'Reward': ViewReward,
    },

    mounted() {
        let params = {
            distId: this.$route.params.distId
        }

        // get exam view information
        examApi.guestExamOnlineView(params).then((response) => {
            this.paperData = response.data.data
            this.periodPolicy = this.paperData.period
            this.summary =  this.paperData.summary
            this.pointPolicy = this.paperData.point
        })

        // get exam badge list
        examApi.guestExamOnlineViewBadges(params).then((response) => {
            this.badges = response.data.data
        })

        // get campaign data
        campaignApi.campaign({locationType: 'IN_INDEPENDENT_EXAM', locationValue: this.$route.params.distId}).then((response) => {
            this.campaignData = response.data.data
        }).catch((err) => {})

    },

    methods: {
        setViewTab(tabType) {
            this.tabType = tabType
        },
        
        // 상하 스크롤 이동시 탭 고정(move up/down scroll fixed tab)
        scrollMove(el) {
            if (parseInt(el.scrollTop) >= parseInt(this.$refs.examHeader.offsetHeight)) {
                this.setTabFixed = true
            }else {
                this.setTabFixed = false
            }
        },
    }

}
</script>